import { useCallback } from "react";

// Try the ProductFruits JavaScript API (preferred — works even when their launcher button
// is hidden or not rendered). Fall back to clicking the DOM launcher as a secondary path.
function openViaApi() {
    if (typeof window === "undefined") return false;
    // ProductFruits v2 SDK exposes window.productFruits.api after initialization.
    const api = window.productFruits?.api;
    if (api?.inAppCenter) {
        api.inAppCenter.open();
        return true;
    }
    // Older SDK shape
    if (api?.button) {
        api.button.showSidebarWidget?.() ?? api.button.click?.();
        return true;
    }
    return false;
}

function openViaLauncher() {
    const el = document.querySelector(".button-launcher");
    if (el) {
        el.click();
        return true;
    }
    return false;
}

const useHelpCenter = () => {
    const openHelpCenter = useCallback(() => openViaApi() || openViaLauncher(), []);

    const isHelpCenterAvailable = () =>
        !!(window.productFruits?.api || document.querySelector(".button-launcher"));

    return { openHelpCenter, isHelpCenterAvailable };
};

export default useHelpCenter;
